import React from 'react';
import { Switch } from '@common/components';

import { PublicRoute } from '@routes/public-route';

import {
  ActivateAccountPage,
  ForgotPasswordPage,
  ResetPasswordPage,
  SignInFailurePage,
  SignInPage,
  SignInSuccessPage,
  SupplierSignUpPage,
} from '@identity/pages';

export function AuthRoutes() {
  return (
    <Switch>
      <PublicRoute path="/works/sign_in" component={SignInPage} />
      <PublicRoute
        path="/works/auth/success/:ssoToken/:email/:entityType/:membershipRole/:membershipId/:ssoOrigin"
        component={SignInSuccessPage}
      />
      <PublicRoute
        path="/works/auth/failure/:error"
        component={SignInFailurePage}
      />
      <PublicRoute
        path="/works/auth/forgot-password"
        component={ForgotPasswordPage}
      />
      <PublicRoute
        path="/works/auth/reset-password/:token"
        component={ResetPasswordPage}
      />
      <PublicRoute
        path="/works/auth/activate-account/:token"
        component={ActivateAccountPage}
      />
      <PublicRoute
        path="/works/supplier/signup/:token"
        component={SupplierSignUpPage}
      />
    </Switch>
  );
}
